import classnames from "classnames";
import {IconType} from "react-icons";
import {FaCloud, FaEnvelope, FaServer, FaSliders} from "react-icons/fa6";

import {CheckUsage} from "@/lib/queries/launchpad.ts";
import {ServiceDefinition, ServiceGroup} from "@/lib/types/checks.ts";
import {BrowserIcon} from "@/pages/launchpad/BrowserIcon.tsx";
import {CheckItem} from "@/pages/launchpad/CheckItem.tsx";

import styles from "./CheckGroup.module.css";

const CheckGroupIcons: Record<string, IconType> = {
  Web: BrowserIcon,
  Network: FaServer,
  Email: FaEnvelope,
  Custom: FaSliders,
  ["Third Party"]: FaCloud,
};

const CheckGroupTooltips: Record<string, string> = {
  Web: "Web checks monitor your home page and key customer pathways",
  Network: "Network checks monitor connectivity and domain registration details",
  Email: "Monitor email servers that send or receive email to catch downtime affecting delivery",
  Custom: "Monitor jobs and processes, issuing alerts according to whether a webhook or heartbeat is received",
  ["Third Party"]: "Monitor third-party services like AWS, Azure, and Google Cloud",
};

interface ChecksGroupProps {
  group: ServiceGroup;
  serviceDefinitions: ServiceDefinition[];
  checksUsage: CheckUsage[];
}

export const ChecksGroup = ({group, serviceDefinitions, checksUsage}: ChecksGroupProps) => {
  const IconComponent = CheckGroupIcons[group.group];
  const tooltip = CheckGroupTooltips[group.group];

  const groupServices = group.types.map((t) => t.name);
  const services = serviceDefinitions.filter((s) => groupServices.includes(s.service_type));
  return (
    <div className="col-md col-sm-12">
      <div
        className={classnames("group-title mb-4 d-flex align-items-center")}
        data-bs-toggle="tooltip"
        title={tooltip}
      >
        {IconComponent && (
          <IconComponent className={classnames(styles.icon, group.group.toLowerCase().replace(/ /g, ""))} />
        )}
        <span className="ms-2 fs-6 p-0">{group.group}</span>
      </div>
      <div>
        <ul className="list-unstyled">
          {services.map((s, idx) => (
            <li className="mb-1" key={idx}>
              <CheckItem
                name={s.verbose_name}
                helpText={s.help_text}
                type={s.service_type}
                supportURL={s.support_link}
                usage={checksUsage.find((u) => u.checkType === s.service_type)?.used || 0}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
